module.exports = __webpack_public_path__ + "assets/img/ms-banner.7a0cd464.png";